import { render, staticRenderFns } from "./SalesDetails.vue?vue&type=template&id=98cfab8c&"
import script from "./SalesDetails.vue?vue&type=script&lang=js&"
export * from "./SalesDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports